import React from "react";
import { useHistory } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  html, body, #root {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
    background: #5872e5ff;
  }
`;

const HomeContainer = styled.div`
  position: relative;
  height: 100vh;
  width: 100vw; /* ensure full width */
  overflow: hidden;
`;

const BgVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  z-index: -1;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 4rem;
  margin-bottom: 2rem;
  font-weight: 700;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.5rem;
  margin-bottom: 3rem;
  opacity: 0.9;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const Button = styled.button`
  font-size: 1.2rem;
  padding: 1rem 2.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 40px rgba(102, 126, 234, 0.6);
  }

  &:active {
    transform: translateY(-1px);
  }
`;

const Home = () => {
  const history = useHistory();

  return (
    <>
      <GlobalStyle /> {/* Inject global reset */}
      <HomeContainer>
        <BgVideo autoPlay muted loop>
          {/* <source src="/videos/intro.mp4" type="video/mp4" /> */}
          Your browser does not support the video tag.
        </BgVideo>
        <Overlay>
          <Title>Video Conference</Title>
          <Subtitle>By Camden Health System</Subtitle>
          <Button onClick={() => history.push("/create")}>
            Start Meeting
          </Button>
        </Overlay>
      </HomeContainer>
    </>
  );
};

export default Home;
